import { createRouter, createWebHistory } from "vue-router";
import MiddlewareProvider from "./middlewares";
import { token } from "./middlewares/token";
import { company } from "./middlewares/company";
import { routes } from "./routes";
import { analytics } from "./middlewares/analytics";
import { useAffiliate } from "@/composables/useAffiliate";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash && to.hash !== "") {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }

    const candidate = document.getElementById("scroll-anchor");

    if (!candidate) return { top: 0, left: 0, behavior: "smooth" };

    return {
      el: "#scroll-anchor",
      behavior: "smooth",
    };
  },
});

MiddlewareProvider.register(router, [useAffiliate().capture, company, token, analytics]);

export default router;
